//import { Component, OnInit } from '@angular/core';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { fuseAnimations } from '@fuse/animations';
import Swal from 'sweetalert2';

///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard-guia/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { WizardN35EncuestadorService } from 'app/main/wizard-n35encuestador/services/wizardn35encuestador.services';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import { ColaboradoresEncuestadorService } from 'app/main/wizard-n35encuestador/services/colaboradoresEncuestador.service';
import { ListaCTService } from 'app/main/pagina/certificarN35/lista-ct/lista-ct.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
@Component({
  selector: 'landing-n35V2',
  templateUrl: './landing-n35V2.component.html',
  styleUrls: ['./landing-n35V2.component.scss'],
  animations : fuseAnimations
})
export class LandingN35ComponentV2 implements OnInit, OnDestroy {
  origen: any;
  productoCertificar: backInter.prodNorma35;
  productosNorma35: backInter.prodNorma35;
  productos: any[] = [
    {
      id      : '1',
      title   : 'WIZARD.LANDING.PRODUCTO.ENCUESTADOR.CURRENT',
      slug    : '/NOM35-ENC/wizard-enc/collaborators',
      category: 'N35',
      length  : 30,
      updated : '30 Agosto 2019',
      responsable : '',
      descripcion : 'WIZARD.LANDING.PRODUCTO.ENCUESTADOR.DESCRIPTION',
      status : 'Pendiente',
      visible: true

    },
    {
      id      : '2',
      title   : 'WIZARD.LANDING.PRODUCTO.GUIA.CURRENT',
      slug    : '/NOM35/wizard/',
      category: 'N35',
      length  : 30,
      updated : '26 Agosto 2019',
      responsable : '',
      descripcion : 'WIZARD.LANDING.PRODUCTO.GUIA.DESCRIPTION',
      status : 'Pendiente',
      visible: true
    },
    {
      id      : '3',
      title   : 'WIZARD.LANDING.PRODUCTO.EXPEDIENTE.CURRENT',
      slug    : '/expedientes',
      category: 'N35',
      length  : 30,
      updated : '30 Agosto 2019',
      responsable : '',
      descripcion : 'WIZARD.LANDING.PRODUCTO.EXPEDIENTE.DESCRIPTION',
      status : 'Pendiente',
      visible: true

    },
    {
      id      : '4',
      title   : 'WIZARD.LANDING.PRODUCTO.CENTROS.CURRENT',
      slug    : '/NOM35/lista-cdt',
      category: 'N35',
      length  : 30,
      updated : '30 Agosto 2019',
      responsable : '',
      descripcion : 'WIZARD.LANDING.PRODUCTO.CENTROS.DESCRIPTION',
      status : 'Pendiente',
      visible: true

    },
    {
      id      : '5',
      title   : 'WIZARD.LANDING.PRODUCTO.RESULTADOS.CURRENT',
      slug    : '/NOM35/resultados',
      category: 'N35',
      length  : 30,
      updated : '30 Agosto 2019',
      responsable : '',
      descripcion : 'WIZARD.LANDING.PRODUCTO.RESULTADOS.DESCRIPTION',
      status : 'Pendiente',
      visible: true

    }
  ];

  landingPrincipal:boolean=true;
  cargando:boolean=true;
  productosAsignados: any[]  =[];

  info : any;
  centroName:any;
  estadocentros=false;
  centrosTrabajo: backInter.getInfoCentros;
  infoCT:any;
  Ctname:any;
  tipoProducto:any;
  landingTit='';

  // PRIVATE
  private _unsubscribeAll: Subject<any>;
  constructor(
    private activatedRoute:ActivatedRoute,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private wizardService35: WizardN35EncuestadorService,
    private colaboradoresService: ColaboradoresEncuestadorService,
    private listaService: ListaCTService,
    private wizardService: WizardService,
  )
  {
    this._unsubscribeAll = new Subject();
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit(): void {
    this.activatedRoute.data.subscribe(params => { this.origen = params;
      console.log('this.origen',this.origen);});
      this._unsubscribeAll.next();
      this._unsubscribeAll.complete();
      if (this.origen.infoLanding35=='NOM35V3') {
        localStorage.setItem('tipoProducto', "NOM35V3");
      }else{
        localStorage.setItem('tipoProducto', "5");

      }
      this.filtraProductosCT();

    // this.modalInformativo();
    // this.obtieneCertificarActual();
    this.obtieneProductos();
  }

  ngOnDestroy(): void
  {
      // Unsubscribe from all subscriptions
      this._unsubscribeAll.next();
      this._unsubscribeAll.complete();
  }

  filtraProductosCT(){
    console.log('entro filtraProductosCT ');

    if(localStorage.getItem('empresaPadre')){
      this.productos[0].visible = false;
      this.productos[3].visible = false;
      this.productos[4].slug = '/NOM35/menu-resultados';
      localStorage.removeItem("ctProductoId");
      localStorage.removeItem("ctSeleccionadoId");
      this.info=this.colaboradoresService.getinfo();
      let pos=0;
    }
  }


  obtieneCertificarActual(){
    this.wizardService35.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      console.log('data',data);

      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            if(producto.completoNorma35 === 1){
              this.productoCertificar = producto;
              this.tipoProducto= this.productoCertificar.tipo;
              console.log(this.productoCertificar);
              console.log(this.tipoProducto);
              localStorage.setItem('productoID', this.productoCertificar.idNorma35);
              if(this.tipoProducto == '2'){
                localStorage.setItem('tipoNorma35', '2');
              }else if(this.tipoProducto == '3'){
                this.productos[1].visible = false;
                this.productos[3].visible = false;
                localStorage.setItem('tipoNorma35', '3');
              }
              else{
                localStorage.setItem('tipoNorma35', '1');
              }
              this.infoCT=this.listaService.getinfo();
              if(this.infoCT.level==6){
                this.listaService.getInfoCentrosTmp(this.productoCertificar.fechaNorma35,this.infoCT.empresaPadre).subscribe( (resu:backInter.getInfoCentros) => {
                  this.centrosTrabajo = resu;

                  for(let k=0; k< this.centrosTrabajo.centros.length;k++){
                    if(this.centrosTrabajo.centros[k].user.user == this.infoCT.user){
                      this.centroName= this.centrosTrabajo.centros[k].centro.nombre_CT;

                    }
                  }
                  this.estadocentros=true;
                });
              }
              throw BreakException;

            }
          });

      } catch (e) {
          if (e !== BreakException) throw e;
      };
      //console.log(this.productoCertificar);
      this.getStatusModal();
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }


  getStatusModal(){
    let datos={
      productoId: this.productoCertificar.idNorma35
    };
    // console.log(datos);
    this.wizardService35.getStatusModal(datos).subscribe( (data: backInter.getN35modal) => {
      if(data.bandera==0){
        this.modalInformativo();
      }
    });
  }

  updateStatusModal(){
    let datos={
      productoId: this.productoCertificar.idNorma35,
      bandera: 1
    };;
    this.wizardService35.updateStatusModal(datos).subscribe( (data: any) => {
      //console.log(data);
    });
  }

  modalInformativo(){
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });

    if(this.tipoProducto == '2'){
      Swal.fire({
        html: '<video src="'+DATOS_API.urlAssets+'video/norma-035_Instruccionales/00.-Bienvenida.mp4" autoplay poster="" style="width:100%;" controlslist="nodownload" ></video>',
        input: "checkbox",
        inputPlaceholder: botonModal,
        allowOutsideClick: false,
        width: '70%'
      }).then((result) => {
        if (result.value == 1){
          this.updateStatusModal();
        }
      });
    }else{
      //DATOS_API.urlAssets+'video/norma35/NOM-035.mp4
      Swal.fire({
        html: '<video src="'+DATOS_API.urlAssets + 'video/normaTips/1. Over view.mp4" autoplay poster="" style="width:100%;" controlslist="nodownload" ></video>',
        input: "checkbox",
        inputPlaceholder: botonModal,
        allowOutsideClick: false,
        width: '70%'
      }).then((result) => {
        if (result.value == 1){
          this.updateStatusModal();
        }
      });
    }


  }

  obtieneProductos(){
    this.wizardService.getProductos().subscribe( (respuesta: backInter.infoProductos) => {
      console.log("xsxas",respuesta);
      let prods: any=[];
      let url: string;
      let nombre: string;
      this.productosAsignados=[];
      switch(this.origen.infoLanding35){
        case 'NOM35':
        // url = 'actionGo_admin/wizard';
        nombre = 'NOM35';
        this.landingTit="WIZARD.LANDING.PRODUCTO.GUIA.NOM35.TITULO_LANFIG";
        respuesta.productosNorma35.forEach(norma35 => {
          if (norma35.tipo==1) {
            prods.push(norma35)

          }
        });
        break;
        case 'NOM35BETHE':
        // url = 'actionGo_admin/wizard';
        this.landingTit="WIZARD.LANDING.PRODUCTO.GUIA.NOM35BETHE.TITULO_LANFIG";
        nombre = 'NOM35BETHE';
        respuesta.productosNorma35.forEach(norma35 => {
          if (norma35.tipo==2) {
            prods.push(norma35)

          }
        });
        break;
        case 'NOM35PLA':
        // url = 'actionGo_admin/wizard';
        this.landingTit="WIZARD.LANDING.PRODUCTO.GUIA.NOM35PLA.TITULO_LANFIG";
        nombre = 'NOM35PLA';
        respuesta.productosNorma35.forEach(norma35 => {
          if (norma35.tipo==3) {
            prods.push(norma35)

          }
        });
        break;
        case 'NOM35V3':
        // url = 'actionGo_admin/wizard';
        this.productos[0].slug="/NOM35-ENC/wizard-enc_t3/collaborators"
        this.landingTit="WIZARD.LANDING.PRODUCTO.GUIA.NOM35.TITULO_LANFIG";
        nombre = 'NOM35V3';
        respuesta.productosNorma35.forEach(norma35 => {
          if (norma35.tipo==4) {
            prods.push(norma35)

          }
        });
        break;

      }
      prods = this.ordenaDescendente(prods, this.origen.infoLanding35);
      this.colocaProductos(nombre,url,prods);
    });
  }

  ordenaDescendente(datos:any, tipo:string){
    switch(tipo){
      case '1': datos.sort( (a,b) => { if(a.fechaCertificar < b.fechaCertificar){ return 1; } else{ return -1; } }); break;
      case '2': datos.sort( (a,b) => { if(a.fechaMedir < b.fechaMedir){ return 1; } else{ return -1; } }); break;
      case '3': datos.sort( (a,b) => { if(a.fechaPulseCheck < b.fechaPulseCheck){ return 1; } else{ return -1; } }); break;
      case '4': datos.sort( (a,b) => { if(a.fechaFocus < b.fechaFocus){ return 1; } else{ return -1; } }); break;
      case 'NOM35': datos.sort( (a,b) => { if(a.fechaNorma35 < b.fechaNorma35){ return 1; } else{ return -1; } }); break;
      case 'NOM35BETHE': datos.sort( (a,b) => { if(a.fechaNorma35 < b.fechaNorma35){ return 1; } else{ return -1; } }); break;
      case 'NOM35PLA': datos.sort( (a,b) => { if(a.fechaNorma35 < b.fechaNorma35){ return 1; } else{ return -1; } }); break;
      case 'NOM35V3': datos.sort( (a,b) => { if(a.fechaNorma35 < b.fechaNorma35){ return 1; } else{ return -1; } }); break;
    }
    return datos;
  }

  colocaProductos(producto:string, url:string, datos:any){
    // console.log(datos);
    datos.forEach( (elem) => {
      let fecha:number;
      let idProductoNorma35:string;
      let completo: number;
      let tagStatus: string;
      let tipo: string;
      let nombre: string;
      switch(producto){
        case 'NOM35':
          fecha = elem.fechaNorma35; idProductoNorma35 = elem.idNorma35;
          completo = elem.completoNorma35; tipo=elem.tipo;
          nombre="WIZARD.LANDING.PRODUCTO.GUIA.NOM35.TITULO_PRODUCT2";
        break;
        case 'NOM35BETHE':
          fecha = elem.fechaNorma35; idProductoNorma35 = elem.idNorma35;
          completo = elem.completoNorma35; tipo=elem.tipo;
          nombre="WIZARD.LANDING.PRODUCTO.GUIA.NOM35BETHE.TITULO_PRODUCT2";
        break;
        case 'NOM35PLA':
          fecha = elem.fechaNorma35; idProductoNorma35 = elem.idNorma35;
          completo = elem.completoNorma35; tipo=elem.tipo;
          nombre="WIZARD.LANDING.PRODUCTO.GUIA.NOM35PLA.TITULO_PRODUCT2";
        break;
        case 'NOM35V3':
          fecha = elem.fechaNorma35; idProductoNorma35 = elem.idNorma35;
          completo = elem.completoNorma35; tipo=elem.tipo;
          nombre="WIZARD.LANDING.PRODUCTO.GUIA.NOM35.TITULO_PRODUCT2";
        break;

      }

      this.productosAsignados.push(
        {
          category: 'CGO',
          length  : 30,
          title   : 'WIZARD.'+producto+'.TITULO',
          fechaNorma35 : fecha,
          // url : url,
          idNorma35 : idProductoNorma35,
          start : 'WIZARD.LANDING.ENTRAR',
          tipo: tipo,
          nombreProducto: nombre,
        }
      );
    });
    this.cargando = false;
    console.log('this.productosAsignados',this.productosAsignados)
  }

  selectProduNorm(producto){
    console.log('Info producto',producto);
    this.productoCertificar = producto;
    console.log(this.productoCertificar);
    this.tipoProducto= this.productoCertificar.tipo;
    console.log(this.tipoProducto);
    localStorage.setItem('productoID',this.productoCertificar.idNorma35);
    localStorage.setItem('FechaNorma',this.productoCertificar.fechaNorma35.toString());
    localStorage.setItem('fechaProductoRequerimientos',this.productoCertificar.fechaNorma35.toString());
    localStorage.setItem('institutoRquerimientos', localStorage.getItem('instituto'));
    localStorage.setItem('productoIDRequerimientos', this.productoCertificar.idNorma35);
    this.landingPrincipal=false;

    if(this.tipoProducto == '2'){
      localStorage.setItem('tipoNorma35', '2');
    }else if(this.tipoProducto == '3'){
      this.productos[1].visible = false;
      this.productos[3].visible = false;
      localStorage.setItem('tipoNorma35', '3');
    }else if(this.tipoProducto == '4'){
      localStorage.setItem('tipoNorma35', 'v3');
      localStorage.setItem('tipoProductoRequerimientos', 'Nom3');
    }
    else{
      localStorage.setItem('tipoNorma35', '1');
      localStorage.setItem('tipoProductoRequerimientos', 'Nom1');
    }
    this.infoCT=this.listaService.getinfo();
    if(this.infoCT.level==6){
      this.listaService.getInfoCentrosTmp(this.productoCertificar.fechaNorma35,this.infoCT.empresaPadre).subscribe( (resu:backInter.getInfoCentros) => {
        this.centrosTrabajo = resu;

        for(let k=0; k< this.centrosTrabajo.centros.length;k++){
          if(this.centrosTrabajo.centros[k].user.user == this.infoCT.user){
            this.centroName= this.centrosTrabajo.centros[k].centro.nombre_CT;

          }
        }
        this.estadocentros=true;
      });
    }
this.getStatusModal();
  }

  regresar(){
    this.landingPrincipal=true;
  }
}
